<template lang="pug">
.section
  .contact-card
    //- Die .window-controls und .title fliegen hier raus!
    .content-area
      .p.name Gabriel Gnatowski
      .p.addr Hinter der Alten Kirche 19
      .p.addr 46446 Emmerich am Rhein
      hr
      .p.email 
        span.label E-Mail: 
        a(href="mailto:gnatowski@web.de") gnatowski@web.de
      .p.phone
        span.label Tel.: 
        a(href="tel:+4915221648102") +49 1522 1648102
</template>

<script>
export default {
  metaInfo: {
    title: "Meine Kontaktdaten",
  },
};
</script>

<style lang="less" scoped>
.section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent; // Der dunkle Hintergrund kommt von der App.vue
}

.contact-card {
  color: #eee;
  background: rgba(44, 62, 80, 0.5); // Leicht transparent für edlen Look
  border: 1px solid #345;
  border-radius: 8px;
  box-shadow: 0 15px 35px rgba(0,0,0,0.3);
  max-width: 450px;
  width: 90%;
}

.content-area {
  padding: 2.5rem;
  text-align: left;
}

.p {
  margin: 0.8rem 0;
  font-family: "Fira Code", monospace;
  font-size: 1.1rem;
}

.label { color: #888; margin-right: 0.5rem; }

hr {
  border: none;
  border-top: 1px solid #345;
  margin: 1.5rem 0;
}

a {
  color: #4af;
  &:hover { color: #fff; text-decoration: underline; }
}
</style>